import { initiale } from "../spieler";
import "./Avatar.css";

/**
 * Runder Spieler-Avatar mit Initiale. farbe: 1..8 (siehe farbNummern in
 * spieler.js), groesse: "klein" | normal | "gross" | "riesig".
 * @category spiel
 */
export function Avatar({ name, farbe = 1, groesse, className, puls = false }) {
  const klassen = ["ava", groesse, puls && "ava-puls", className].filter(Boolean).join(" ");
  return (
    <span className={klassen} data-farbe={farbe} aria-hidden="true">
      {initiale(name)}
    </span>
  );
}

export default Avatar;
